import organizations from '@/apis/coreIAM/organizations'
import { organizationsTypes } from '@/store/mutationTypes'

export default {
    state: {
        organizationGroups: [],
        fetchAllOrganizationGroups: {
            pending: false,
            error: null,
        },
        fetchOrganizationGroup: {
            pending: false,
            error: null,
        },
        createOrganizationGroup: {
            pending: false,
            error: null,
        },
        updateOrganizationGroup: {
            pending: false,
            error: null,
        },
        deleteOrganizationGroup: {
            pending: false,
            error: null,
        },
        fetchOrganizationGroupUsers: {
            pending: false,
            error: null,
        },
        addUserToOrganizationGroup: {
            pending: false,
            error: null,
        },
        removeUserFromOrganizationGroup: {
            pending: false,
            error: null,
        },
        fetchAvailableGroupRoles: {
            pending: false,
            error: null,
        },
        fetchOrganizationGroupRoles: {
            pending: false,
            error: null,
        },
        addOrganizationGroupRole: {
            pending: false,
            error: null,
        },
        removeOrganizationGroupRole: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [organizationsTypes.FETCH_ALL_ORGANIZATION_GROUPS_REQUEST]: function (state) {
            state.fetchAllOrganizationGroups.pending = true;
        },
        [organizationsTypes.FETCH_ALL_ORGANIZATION_GROUPS_SUCCESS]: function (state, groups) {
            state.organizationGroups = groups;
            state.fetchAllOrganizationGroups.error = null;
            state.fetchAllOrganizationGroups.pending = false;
        },
        [organizationsTypes.FETCH_ALL_ORGANIZATION_GROUPS_FAILURE]: function (state, error) {
            state.organizationGroups = [];
            state.fetchAllOrganizationGroups.error = error;
            state.fetchAllOrganizationGroups.pending = false;
        },
        [organizationsTypes.FETCH_ORGANIZATION_GROUP_REQUEST]: function (state) {
            state.fetchOrganizationGroup.pending = true;
        },
        [organizationsTypes.FETCH_ORGANIZATION_GROUP_SUCCESS]: function (state) {
            state.fetchOrganizationGroup.error = null;
            state.fetchOrganizationGroup.pending = false;
        },
        [organizationsTypes.FETCH_ORGANIZATION_GROUP_FAILURE]: function (state, error) {
            state.fetchOrganizationGroup.error = error;
            state.fetchOrganizationGroup.pending = false;
        },
        [organizationsTypes.CREATE_ORGANIZATION_GROUP_REQUEST]: function (state) {
            state.createOrganizationGroup.pending = true;
        },
        [organizationsTypes.CREATE_ORGANIZATION_GROUP_SUCCESS]: function (state) {
            state.createOrganizationGroup.error = null;
            state.createOrganizationGroup.pending = false;
        },
        [organizationsTypes.CREATE_ORGANIZATION_GROUP_FAILURE]: function (state, error) {
            state.createOrganizationGroup.error = error;
            state.createOrganizationGroup.pending = false;
        },
        [organizationsTypes.UPDATE_ORGANIZATION_GROUP_REQUEST]: function (state) {
            state.updateOrganizationGroup.pending = true;
        },
        [organizationsTypes.UPDATE_ORGANIZATION_GROUP_SUCCESS]: function (state) {
            state.updateOrganizationGroup.error = null;
            state.updateOrganizationGroup.pending = false;
        },
        [organizationsTypes.UPDATE_ORGANIZATION_GROUP_FAILURE]: function (state, error) {
            state.updateOrganizationGroup.error = error;
            state.updateOrganizationGroup.pending = false;
        },
        [organizationsTypes.DELETE_ORGANIZATION_GROUP_REQUEST]: function (state) {
            state.deleteOrganizationGroup.pending = true;
        },
        [organizationsTypes.DELETE_ORGANIZATION_GROUP_SUCCESS]: function (state) {
            state.deleteOrganizationGroup.error = null;
            state.deleteOrganizationGroup.pending = false;
        },
        [organizationsTypes.DELETE_ORGANIZATION_GROUP_FAILURE]: function (state, error) {
            state.deleteOrganizationGroup.error = error;
            state.deleteOrganizationGroup.pending = false;
        },
        [organizationsTypes.FETCH_ALL_ORGANIZATION_GROUP_USERS_REQUEST]: function (state) {
            state.fetchOrganizationGroupUsers.pending = true;
        },
        [organizationsTypes.FETCH_ALL_ORGANIZATION_GROUP_USERS_SUCCESS]: function (state) {
            state.fetchOrganizationGroupUsers.error = null;
            state.fetchOrganizationGroupUsers.pending = false;
        },
        [organizationsTypes.FETCH_ALL_ORGANIZATION_GROUP_USERS_FAILURE]: function (state, error) {
            state.fetchOrganizationGroupUsers.error = error;
            state.fetchOrganizationGroupUsers.pending = false;
        },
        [organizationsTypes.ADD_USER_TO_ORGANIZATION_GROUP_REQUEST]: function (state) {
            state.addUserToOrganizationGroup.pending = true;
        },
        [organizationsTypes.ADD_USER_TO_ORGANIZATION_GROUP_SUCCESS]: function (state) {
            state.addUserToOrganizationGroup.error = null;
            state.addUserToOrganizationGroup.pending = false;
        },
        [organizationsTypes.ADD_USER_TO_ORGANIZATION_GROUP_FAILURE]: function (state, error) {
            state.addUserToOrganizationGroup.error = error;
            state.addUserToOrganizationGroup.pending = false;
        },
        [organizationsTypes.REMOVE_USER_FROM_ORGANIZATION_GROUP_REQUEST]: function (state) {
            state.removeUserFromOrganizationGroup.pending = true;
        },
        [organizationsTypes.REMOVE_USER_FROM_ORGANIZATION_GROUP_SUCCESS]: function (state) {
            state.removeUserFromOrganizationGroup.error = null;
            state.removeUserFromOrganizationGroup.pending = false;
        },
        [organizationsTypes.REMOVE_USER_FROM_ORGANIZATION_GROUP_FAILURE]: function (state, error) {
            state.removeUserFromOrganizationGroup.error = error;
            state.removeUserFromOrganizationGroup.pending = false;
        },
        [organizationsTypes.FETCH_AVAILABLE_GROUP_ROLES_REQUEST]: function (state) {
            state.fetchAvailableGroupRoles.pending = true;
        },
        [organizationsTypes.FETCH_AVAILABLE_GROUP_ROLES_SUCCESS]: function (state) {
            state.fetchAvailableGroupRoles.error = null;
            state.fetchAvailableGroupRoles.pending = false;
        },
        [organizationsTypes.FETCH_AVAILABLE_GROUP_ROLES_FAILURE]: function (state, error) {
            state.fetchAvailableGroupRoles.error = error;
            state.fetchAvailableGroupRoles.pending = false;
        },
        [organizationsTypes.FETCH_ORGANIZATION_GROUP_ROLES_REQUEST]: function (state) {
            state.fetchOrganizationGroupRoles.pending = true;
        },
        [organizationsTypes.FETCH_ORGANIZATION_GROUP_ROLES_SUCCESS]: function (state) {
            state.fetchOrganizationGroupRoles.error = null;
            state.fetchOrganizationGroupRoles.pending = false;
        },
        [organizationsTypes.FETCH_ORGANIZATION_GROUP_ROLES_FAILURE]: function (state, error) {
            state.fetchOrganizationGroupRoles.error = error;
            state.fetchOrganizationGroupRoles.pending = false;
        },
        [organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_REQUEST]: function (state) {
            state.addOrganizationGroupRole.pending = true;
        },
        [organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_SUCCESS]: function (state) {
            state.addOrganizationGroupRole.error = null;
            state.addOrganizationGroupRole.pending = false;
        },
        [organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_FAILURE]: function (state, error) {
            state.addOrganizationGroupRole.error = error;
            state.addOrganizationGroupRole.pending = false;
        },
        [organizationsTypes.REMOVE_ORGANIZATION_GROUP_ROLE_REQUEST]: function (state) {
            state.removeOrganizationGroupRole.pending = true;
        },
        [organizationsTypes.REMOVE_ORGANIZATION_GROUP_ROLE_SUCCESS]: function (state) {
            state.removeOrganizationGroupRole.error = null;
            state.removeOrganizationGroupRole.pending = false;
        },
        [organizationsTypes.REMOVE_ORGANIZATION_GROUP_ROLE_FAILURE]: function (state, error) {
            state.removeOrganizationGroupRole.error = error;
            state.removeOrganizationGroupRole.pending = false;
        },
    },
    actions: {
        async fetchAllOrganizationGroups({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_ORGANIZATION_GROUPS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations.listOrganizationGroups(payload.organizationUuid)
                    .then((groups) => {
                        commit(organizationsTypes.FETCH_ALL_ORGANIZATION_GROUPS_SUCCESS, groups.data)
                        resolve(groups.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_ORGANIZATION_GROUPS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchOrganizationGroup({ commit }, payload) {
            commit(organizationsTypes.FETCH_ORGANIZATION_GROUP_REQUEST)
            return new Promise((resolve, reject) => {
                organizations.getOrganizationGroup(payload.organizationUuid, payload.groupUuid)
                    .then((group) => {
                        commit(organizationsTypes.FETCH_ORGANIZATION_GROUP_SUCCESS)
                        resolve(group.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ORGANIZATION_GROUP_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async createOrganizationGroup({ commit }, payload) {
            commit(organizationsTypes.CREATE_ORGANIZATION_GROUP_REQUEST)
            return new Promise((resolve, reject) => {
                organizations.createOrganizationGroup(payload.organizationUuid, payload.groupName)
                    .then((group) => {
                        commit(organizationsTypes.CREATE_ORGANIZATION_GROUP_SUCCESS)
                        resolve(group.data)
                    }).catch((error) => {
                        commit(organizationsTypes.CREATE_ORGANIZATION_GROUP_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async updateOrganizationGroup({ commit }, payload) {
            commit(organizationsTypes.UPDATE_ORGANIZATION_GROUP_REQUEST)
            return new Promise((resolve, reject) =>
                organizations
                    .updateOrganizationGroup(
                        payload.organizationUuid,
                        payload.groupUuid,
                        payload.groupName,
                    ).then((group) => {
                        commit(organizationsTypes.UPDATE_ORGANIZATION_GROUP_SUCCESS)
                        resolve(group.data)
                    }).catch((error) => {
                        commit(organizationsTypes.UPDATE_ORGANIZATION_GROUP_FAILURE, error)
                        reject(error)
                    })
            )
        },
        async deleteOrganizationGroup({ commit }, payload) {
            commit(organizationsTypes.DELETE_ORGANIZATION_GROUP_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .deleteOrganizationGroup(
                        payload.organizationUuid,
                        payload.groupUuid,
                    ).then(() => {
                        commit(organizationsTypes.DELETE_ORGANIZATION_GROUP_SUCCESS)
                        resolve()
                    }).catch((error) => {
                        commit(organizationsTypes.DELETE_ORGANIZATION_GROUP_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async fetchOrganizationGroupUsers({ commit }, payload) {
            commit(organizationsTypes.FETCH_ALL_ORGANIZATION_GROUP_USERS_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listOrganizationGroupUsers(
                        payload.organizationUuid,
                        payload.groupUuid,
                    ).then((users) => {
                        commit(organizationsTypes.FETCH_ALL_ORGANIZATION_GROUP_USERS_SUCCESS)
                        resolve(users.data)
                    }).catch((error) => {
                        commit(organizationsTypes.FETCH_ALL_ORGANIZATION_GROUP_USERS_FAILURE, error)
                        reject(error)
                    })
            })
        },
        addUserToOrganizationGroup({ commit }, payload) {
            commit(organizationsTypes.ADD_USER_TO_ORGANIZATION_GROUP_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addUserToOrganizationGroup(
                        payload.organizationUuid,
                        payload.groupUuid,
                        payload.userUuid,
                    )
                    .then(() => {
                        commit(organizationsTypes.ADD_USER_TO_ORGANIZATION_GROUP_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(organizationsTypes.ADD_USER_TO_ORGANIZATION_GROUP_FAILURE, error)
                        reject(error)
                    })
            })
        },
        removeUserFromOrganizationGroup({ commit }, payload) {
            commit(organizationsTypes.REMOVE_USER_FROM_ORGANIZATION_GROUP_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeUserFromOrganizationGroup(
                        payload.organizationUuid,
                        payload.groupUuid,
                        payload.userUuid,
                    )
                    .then(() => {
                        commit(organizationsTypes.REMOVE_USER_FROM_ORGANIZATION_GROUP_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(organizationsTypes.REMOVE_USER_FROM_ORGANIZATION_GROUP_FAILURE, error)
                        reject(error)
                    })
            })
        },
        fetchAvailableGroupRoles({ commit }, payload) {
            commit(organizationsTypes.FETCH_AVAILABLE_GROUP_ROLES_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listAvailableOrganizationGroupRoles(
                        payload.organizationUuid,
                        payload.groupUuid,
                    )
                    .then((roles) => {
                        commit(organizationsTypes.FETCH_AVAILABLE_GROUP_ROLES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.FETCH_AVAILABLE_GROUP_ROLES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        fetchOrganizationGroupRoles({ commit }, payload) {
            commit(organizationsTypes.FETCH_ORGANIZATION_GROUP_ROLES_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .listOrganizationGroupRoles(
                        payload.organizationUuid,
                        payload.groupUuid,
                    )
                    .then((roles) => {
                        commit(organizationsTypes.FETCH_ORGANIZATION_GROUP_ROLES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(organizationsTypes.FETCH_ORGANIZATION_GROUP_ROLES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        addOrganizationGroupRole({ commit }, payload) {
            commit(organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .addOrganizationGroupRole(
                        payload.organizationUuid,
                        payload.groupUuid,
                        payload.roleUuid,
                        payload.roleName,
                    )
                    .then(() => {
                        commit(organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_FAILURE, error)
                        reject(error)
                    })
            })
        },
        removeOrganizationGroupRole({ commit }, payload) {
            commit(organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_REQUEST)
            return new Promise((resolve, reject) => {
                organizations
                    .removeOrganizationGroupRole(
                        payload.organizationUuid,
                        payload.groupUuid,
                        payload.roleUuid,
                        payload.roleName,
                    )
                    .then(() => {
                        commit(organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_SUCCESS)
                        resolve()
                    })
                    .catch((error) => {
                        commit(organizationsTypes.ADD_ORGANIZATION_GROUP_ROLE_FAILURE, error)
                        reject(error)
                    })
            })
        },
    },
}